import React from 'react';
import './BusinessFeauters.css'
import BusinessFeatureTabs from './BusinessFeatureTabs/BusinessFeatureTabs'

const BusinessFeauters = () => {
    return (
        <section className="feauters-section">
            {/* === Business Features Tabs heading === */}
            <div className="feauters-section-heading">
                <div className="container">
                    <div className="feauters-heading-content">
                        <h1 className="invisible-title">Feauters</h1>
                        <h2 className="heading-title">More ExcitingFeatures</h2>
                        <div className="features-separetor"></div>
                    </div>
                </div>
            </div>
            {/* === Business features tabs all content === */}
            <BusinessFeatureTabs />
        </section>
    )
}

export default BusinessFeauters
